/**
 * Main App - React Router Setup with Ant Design Mobile
 */

import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import { ConfigProvider } from 'antd-mobile';
import thTH from 'antd-mobile/es/locales/th-TH';

// Lazy load pages for better performance
const Register = lazy(() => import('./pages/Register'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const Payment = lazy(() => import('./pages/Payment'));
const Admin = lazy(() => import('./pages/Admin'));
const Profile = lazy(() => import('./pages/Profile'));
const Scan = lazy(() => import('./pages/Scan'));
const Welcome = lazy(() => import('./pages/Welcome'));
const FoodHistory = lazy(() => import('./pages/FoodHistory'));
const ExerciseHistory = lazy(() => import('./pages/ExerciseHistory'));

// Yai Cal Animated Loader
function YaiCalLoader() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-emerald-50 to-white">
      <div className="flex flex-col items-center gap-6">
        <div className="w-40 h-40">
          <img
            src="/mascot.png"
            alt="Loading..."
            className="w-full h-full object-contain animate-bounce"
          />
        </div>
        <div className="text-center">
          <h2 className="text-2xl font-bold text-slate-700">
            รอแป๊บนึงน้า...
          </h2>
          <p className="text-emerald-600 text-base mt-2">
            ยัยแคลกำลังโหลด 🥑💪
          </p>
        </div>
      </div>
    </div>
  );
}

// Component to handle LIFF routing via liff.state parameter
function LiffRouter() {
  const [searchParams] = useSearchParams();

  const liffState = searchParams.get('liff.state');
  const page = searchParams.get('page');

  let targetPage = '';

  if (liffState) {
    if (liffState.includes('=')) {
      targetPage = liffState.split('=').pop() || '';
    } else {
      targetPage = liffState;
    }
  }

  if (!targetPage && page) {
    targetPage = page;
  }

  if (targetPage === 'profile') return <Profile />;
  if (targetPage === 'payment') return <Payment />;
  if (targetPage === 'register') return <Register />;
  if (targetPage === 'scan') return <Scan />;
  if (targetPage === 'welcome') return <Welcome />;
  if (targetPage === 'food-history') return <FoodHistory />;
  if (targetPage === 'exercise-history') return <ExerciseHistory />;

  return <Dashboard />;
}

function App() {
  return (
    <ConfigProvider locale={thTH}>
      <BrowserRouter>
        <Suspense fallback={<YaiCalLoader />}>
          <Routes>
            <Route path="/" element={<LiffRouter />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/scan" element={<Scan />} />
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/food-history" element={<FoodHistory />} />
            <Route path="/exercise-history" element={<ExerciseHistory />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
